import classNames from 'classnames';

import Block from '../block';
import {backgroundColour, backgroundPattern} from '../../utils/block-utils';

export const getAuthFormWidthClassName = width => ({
    narrow: 'max-w-sm',
    standard: 'max-w-xl',
    wide: 'max-w-3xl'
}[width] || 'max-w-xl');

export const getAuthFormAlignmentClassName = alignment => ({
    left: 'mr-auto',
    centre: 'mx-auto',
    right: 'ml-auto'
}[alignment] || 'mx-auto');

export const getAuthFormContainerClassName = containerStyle => classNames(
    containerStyle === 'plain' ? 'py-4' : 'rounded-theme section section-grey border'
);

export default function AuthFormShell({children, defaultWidth = 'standard', ...props}) {
    const options = props.values?.options || {};
    const inset = options.inset === true;

    return (
        <Block
            {...props}
            className={classNames(
                props.className,
                !inset ? backgroundPattern(props) : null,
                !inset ? backgroundColour(options.backgroundColour) : null
            )}
        >
            <div className={classNames(
                'w-full section !px-0',
                getAuthFormWidthClassName(options.formWidth || defaultWidth),
                getAuthFormAlignmentClassName(options.formAlignment),
                inset ? 'rounded-theme' : null,
                inset ? backgroundPattern(props) : null,
                inset ? backgroundColour(options.backgroundColour) : null
            )}>
                <div className={getAuthFormContainerClassName(options.containerStyle)}>
                    {children}
                </div>
            </div>
        </Block>
    );
}
